// context/AuthContext.js
import { logout } from "components/auth/auth";
import React,{ createContext, useContext, useState, useEffect } from "react";
import  supabaseHandler  from "utils/SupaBase"; // adjust path to your Supabase client

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSession = async () => {
      const { data, error } = await supabaseHandler.auth.getSession();
    
      if (error) {
        console.error("Error getting session:", error);
        setUser(null);
        setToken(null);
        setLoading(false);
        return;
      }
    
      const session = data?.session;
    
      if (!session?.access_token) {
        setUser(null);
        setToken(null);
        setLoading(false);
        return;
      }
    
      setUser(session.user);
      setToken(session.access_token);
      setLoading(false);
    };
    

    loadSession();

    const { data: authListener } =
  supabaseHandler.auth.onAuthStateChange((event, session) => {

    if (event === "SIGNED_OUT") {
      setUser(null);
      setToken(null);
      return;
    }

    if (event === "TOKEN_REFRESH_FAILED") {
      logout(); // ✅ ONLY here
      return;
    }

    if (session?.access_token) {
      setUser(session.user);
      setToken(session.access_token);
    }
  });

  

    // Listen for localStorage changes (e.g., when user signs up/logs in from another tab or component)
    const handleStorageChange = (e) => {
      if (e.key === 'user' || e.key === null) {
        // Reload session when user data changes in localStorage
        loadSession();
      }
    };

    // Listen for custom event when localStorage is updated from same tab
    const handleAuthUpdate = () => {
      loadSession();
    };

    

    return () => {
      authListener?.subscription?.unsubscribe();
     
    };
  }, []);

  return (
    <AuthContext.Provider value={{ user, token, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};